import { useSelector } from 'react-redux';
import { Navigate, useLocation } from 'react-router-dom';

export default function PrivateRoutes({ children }) {
  const userStore = useSelector((store) => store.UserReducer);
  const location = useLocation();

  // Fallback: check localStorage token if Redux state is not yet updated
  const tokenFromStorage = JSON.parse(localStorage.getItem('user'))?.token;
  const isAuthenticated = userStore?.isAuth || Boolean(tokenFromStorage);

  if (!isAuthenticated) {
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  return <>{children}</>;
}
